import { render, staticRenderFns } from "./AdminBerlinale.vue?vue&type=template&id=b7fa76b6&scoped=true"
import script from "./AdminBerlinale.vue?vue&type=script&lang=js"
export * from "./AdminBerlinale.vue?vue&type=script&lang=js"
import style0 from "./AdminBerlinale.vue?vue&type=style&index=0&id=b7fa76b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fa76b6",
  null
  
)

export default component.exports